import type { ColumnType } from 'antd/es/table';

import type { CreditorKeyValuePair, CreditorWithDetails } from 'api';

import { ColumnTitle } from '@atoms/ColumnTitle';
import { ReceiverIcon } from '@atoms/Icon/ReceiverIcon';

export const getColumns = (): ColumnType<CreditorWithDetails>[] => {
  return [
    {
      dataIndex: 'icon',
      key: 'icon',
      width: 100,
      render: () => (
        <div className="flex justify-center">
          <ReceiverIcon width={32} height={32} />
        </div>
      )
    },
    {
      title: <ColumnTitle title="Full name" />,
      dataIndex: 'full_name',
      key: 'full_name',
      render: (fullName: string) => (
        <div>
          <p className="text-md">{fullName}</p>
        </div>
      )
    },
    {
      title: <ColumnTitle title="Account" />,
      key: 'account',
      dataIndex: 'creditor_details',
      render: (creditorDetails: CreditorKeyValuePair[]) => {
        const getValue = (key: string) =>
          creditorDetails.find((credDetail) => credDetail.key === key)?.value;

        const ibanValue = getValue('creditor_account.iban');
        const accountValue = getValue('creditor_account.account');
        const accountNumberValue = getValue('creditor_account.account_number');
        const cryptoValue = getValue('creditor_account.crypto_wallet_address');
        const currencyValue = getValue('creditor_account.currency');

        return (
          <div>
            <p className="text-sm">
              {ibanValue ?? accountNumberValue ?? accountValue ?? cryptoValue}
            </p>
            <div className="font-semibold">{currencyValue ?? ''}</div>
          </div>
        );
      }
    },
    {
      title: <ColumnTitle title="Address" />,
      dataIndex: 'address_lines',
      key: 'address',
      render: (addressLines: string, record: CreditorWithDetails) => {
        return (
          <div>
            <p className="text-sm">{addressLines}</p>
            <div className="font-semibold">{record.country_code}</div>
          </div>
        );
      }
    }
  ];
};
